<button
  class="app-switcher"
  [ngClass]="{'active': isOpened}"
  (click)="toggle()"
>
  <label></label>
</button>
